import { toast } from 'react-toastify';

(function () {
  if (typeof window === 'undefined') return;

  let lastDevtoolsToastAt = 0;
  let lastContextToastAt = 0;
  let lastSelectToastAt = 0;
  const TOAST_COOLDOWN_MS = 3000;

  const safeToast = (type, message) => {
    try {
      const now = Date.now();
      if (type === 'devtools') {
        if (now - lastDevtoolsToastAt < TOAST_COOLDOWN_MS) return;
        lastDevtoolsToastAt = now;
      } else if (type === 'context') {
        if (now - lastContextToastAt < TOAST_COOLDOWN_MS) return;
        lastContextToastAt = now;
      } else if (type === 'select') {
        if (now - lastSelectToastAt < TOAST_COOLDOWN_MS) return;
        lastSelectToastAt = now;
      }
      toast.warn(message, { position: 'top-center', autoClose: 2000, pauseOnHover: false });
    } catch (_) {
      // no-op if toast not ready yet
    }
  };

  const isOneSignalElement = (el) => {
    try {
      if (!el) return false;
      if (
        el.closest &&
        el.closest(
          '[id*="onesignal"], [class*="onesignal"], [data-one-signal], #onesignal-bell-container, .onesignal-bell-launcher',
        )
      ) {
        return true;
      }
      const active = document.activeElement;
      if (active && active.tagName === 'IFRAME' && (active.src || '').includes('onesignal')) {
        return true;
      }
    } catch (_) {
      /* no-op */
    }
    return false;
  };

  const onKeyDown = (e) => {
    try {
      if (isOneSignalElement(e.target)) return;

      const key = (e.key || '').toUpperCase();
      const isF12 = key === 'F12';
      const winLinuxCombos = e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(key);
      const macCombos = e.metaKey && e.altKey && ['I', 'J', 'C'].includes(key);

      if (isF12 || winLinuxCombos || macCombos) {
        e.preventDefault();
        e.stopPropagation();
        safeToast('devtools', 'Đã chặn phím tắt mở Developer Tools');
        return false;
      }
    } catch (err) {
      // no-op
    }
  };

  const onContextMenu = (e) => {
    if (isOneSignalElement(e.target)) return;
    e.preventDefault();
    safeToast('context', 'Chuột phải đã bị vô hiệu hóa');
  };

  const onDragStart = (e) => {
    const t = e.target;
    if (isOneSignalElement(t)) return;
    if (t && (t.tagName === 'IMG' || (t.closest && t.closest('img')))) {
      e.preventDefault();
    }
  };

  const onSelectStart = (e) => {
    if (isOneSignalElement(e.target)) return false;
    e.preventDefault();
    safeToast('select', 'Không được phép chọn và copy nội dung');
    return false;
  };

  // Apply CSS to disable text selection
  const disableTextSelection = () => {
    try {
      const style = document.createElement('style');
      style.id = 'disable-text-selection-style';
      style.textContent = `
        * {
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }
        input, textarea {
          -webkit-user-select: text;
          -moz-user-select: text;
          -ms-user-select: text;
          user-select: text;
        }
      `;
      document.head.appendChild(style);
    } catch (err) {
      console.warn('Failed to apply text selection CSS', err);
    }
  };

  try {
    window.addEventListener('keydown', onKeyDown, true);
    window.addEventListener('contextmenu', onContextMenu, true);
    window.addEventListener('dragstart', onDragStart, true);
    window.addEventListener('selectstart', onSelectStart, true);

    // Apply CSS to disable text selection
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', disableTextSelection);
    } else {
      disableTextSelection();
    }
  } catch (err) {
    console.warn('disableContextMenu attach failed', err);
  }
})();
